import { ReactElement } from 'react';

import { VisitPrescription } from '@dreryk/egabinet-visit-frontend-api';

import { Translate } from '@dreryk/react-common';

import { useFormatStages } from '~libs.desktop.shared.medicine';
import { formatPreciseDosage } from '~libs.shared.prescription';

import { historicalVisitsTranslationKeys } from '../../translations';

type HistoricalVisitPrescriptionDosageProps = {
   prescription: VisitPrescription;
};

export const HistoricalVisitPrescriptionDosage = (props: HistoricalVisitPrescriptionDosageProps): ReactElement => {
   const { preciseDosage, extendedDosage, dosage } = props.prescription;
   const formatStages = useFormatStages();
   const extendedDosageActive = Boolean(extendedDosage?.stages.length);
   return (
      <div>
         <Translate>{historicalVisitsTranslationKeys.historicalVisit.DS}</Translate>{' '}
         {[
            ...formatStages(extendedDosage?.stages ?? [], extendedDosage?.portionUnit),
            !extendedDosageActive && preciseDosage ? formatPreciseDosage(preciseDosage) : null,
            dosage,
         ]
            .filter(Boolean)
            .join(', ')}
      </div>
   );
};
